import { observable, action, computed } from 'mobx';
import agent from '../services/web/agent';
import userSharedFormsValidator from '../services/validations/userSharedFormsValidator';
import ConfigurationsStore from './configurationsStore';
const queryString = require("query-string");
import CommonValidator from '../services/validations/commonValidators';

class AuthStore {

    DEFAULT_AUTH_PROVIDER_ID = window.localStorage.getItem('defaultSelectedAuthProviderId') || 1;

    @observable inProgress = false;
    @observable errors = null;
    @observable isLoginError = null;
    @observable requireChangePasswordForResetFlow = false;

    @observable loginErrorMessage = null;
    @observable userNameValidationMessage;
    @observable passwordValidationMessage;
    @observable tenantValidationMessage;
    @observable requireTwoFactorAuth = false;
    @observable twoFactorErrorMessage;
    @observable isTwoFactorError = false;
    @observable recoveryCodeErrorMessage
    @observable isRecoveryCodeError = false;
    @observable loginCurrentStep;
    @observable requireTwoFASetupToBeDone = false;

    @observable loginSteps = {
        'tenantForm': 'tenantForm',
        'passwordForm': 'passwordForm',
        'twoFAForm': 'twoFAForm',
        'recoveryCodeForm': 'recoveryCodeForm',
        'passwordExpired' : 'passwordExpired'
    }

    formErrors = [];

    @observable values = {
        userName: '',
        password: '',
        tenant: window.localStorage.getItem('authStoreTenant') || '',
        providerId: window.localStorage.getItem('authStoreProviderId')
            || this.DEFAULT_AUTH_PROVIDER_ID,
        isAcceptedEula: false,
        authenticationCode: '',
        isPasswordValidated: false,
        recoveryCode: '',
        isRecovery: false,
        rememberTwoFABrowser: false,
		accessIsFromACUI: true
    };

    @action setRequireTwoFASetupToBeDone(val) {
        this.requireTwoFASetupToBeDone = val;
    }

    @action SetIsTwoFactorSet(val) {
        this.IsTwoFactorSet = val;
    }

    @action setOrigin() {
        const urlResult = (queryString.parse(window.location.hash))["/login?ReturnUrl"];
        const { acr_values = "" } = queryString.parse(urlResult);
        
        if (acr_values && acr_values.length > 0) {
            var acr_valArray = [];
            acr_valArray = acr_values.split(' ');

            for (let i = 0; i < acr_valArray.length; i++) {
               if (acr_valArray[i].includes("cxOrigin")) {
                    this.values.origin = acr_valArray[i].substr(acr_valArray[i].indexOf(':') + 1);
                    break;
                }
            }
        }
    }
    @action setLoginStep(step) {
        this.loginCurrentStep = step;
    }

    @action setUserName(userName) {
        this.values.userName = userName.trim();
    }

    @action setPassword(password) {
        this.values.password = password;
    }

    @action setTenant(tenant) {
        this.values.tenant = tenant;
    }

    @action setProviderId(providerId) {
        this.values.providerId = providerId;
        window.localStorage.setItem('authStoreProviderId', providerId);
    }

    @action toggleAcceptedEula() {
        this.values.isAcceptedEula = !this.values.isAcceptedEula;
    }

    @action setRequireChangePasswordForResetFlow(shouldChange) {
        this.requireChangePasswordForResetFlow = shouldChange;
    }

    @action setRequireTwoFactorAuth(requireAuth) {
        this.requireTwoFactorAuth = requireAuth;
    }

    @action setRecoveryCode(code) {
        this.values.recoveryCode = code;
    }

    @action setIsRecovery(isRedeem) {
        this.values.isRecovery = isRedeem;
    }

    @action setAuthCode(code) {
        this.values.authenticationCode = code;
    }

    @action setInProgress(status) {
        this.inProgress = status;
    }

    @action resetTenantForm() {
        this.reset();
        this.tenantValidationMessage = '';
    }

    @action resetPasswordForm() {
        this.reset();
        this.values.password = '';
        this.inProgress = false;
        this.values.isAcceptedEula = false;
        this.setProviderId(this.DEFAULT_AUTH_PROVIDER_ID);
        this.userNameValidationMessage = '';
        this.passwordValidationMessage = '';
    }

    @action resetTwoFAForm() {
        this.reset();
        this.isTwoFactorError = false;
        this.twoFactorErrorMessage = '';
        this.values.authenticationCode = '';
    }

    @action resetRecoveryForm() {
        this.reset();
        this.isRecoveryCodeError = false;
        this.recoveryCodeErrorMessage = '';
        this.values.recoveryCode = '';
        this.values.isRecovery = false;
    }

    @action reset() {
        this.formErrors = [];              
        this.inProgress = false;
        this.errors = null;
        this.isLoginError = null;
        this.loginErrorMessage = null;
    }

    @action toggleRememberTwoFABrowser() {
        this.values.rememberTwoFABrowser = !this.values.rememberTwoFABrowser;
    }

    @action
    async login() {

        this.inProgress = true;
        this.errors = undefined;

        let tenant = ConfigurationsStore.isMultitenancyMode ? this.values.tenant.trim() : ConfigurationsStore.defaultTenantName;

        return agent.Auth.login(this.values.userName, this.values.password, this.values.providerId, tenant, this.values.isAcceptedEula, this.values.origin, this.values.authenticationCode, this.values.isPasswordValidated, this.values.recoveryCode, this.values.rememberTwoFABrowser, this.values.accessIsFromACUI)
            .catch(action((err) => {

                        this.inProgress = false;

                        if (err && err.response && err.response.text) {
                            if (this.values.isPasswordValidated) {
                                if (this.values.isRecovery) {
                                    this.isRecoveryCodeError = true;
                                    this.recoveryCodeErrorMessage = JSON.parse(err.response.text).Message;
                                }
                                else {
                                    this.isTwoFactorError = true;
                                    this.twoFactorErrorMessage = JSON.parse(err.response.text).Message;
                                }
                            }
                            else {
                                this.isLoginError = true;
                                this.loginErrorMessage = JSON.parse(err.response.text).Message;
                            }
                        }
                        this.errors = err.response && err.response.body && err.response.body.errors;
                        throw err;

                    }));
    }


    @observable loadingSessionTimeout;
    @observable sessionTimeout;

    @action getSessionTimeout() {

        this.loadingSessionTimeout = true;

        return agent.SessionTimeout.getSessionTimeout()
                    .then(action((sessionTimeout) => {

                        this.sessionTimeout = sessionTimeout;
                    }))
                    .finally(action(() => {

                        this.loadingSessionTimeout = false;
                    }));
    }


    validateUserName() {
        const validation = userSharedFormsValidator.validateUserName(this.values.userName);

        this.userNameValidationMessage = validation.errors.first('userName');

        this.formErrors.push(validation.errorCount);
    }

    validatePassword() {
        const validation = userSharedFormsValidator.validateGenericRequiredField(this.values.password);

        this.passwordValidationMessage = validation.errors.first('field');

        this.formErrors.push(validation.errorCount);
    }

    validateTenant() {
        const validation = userSharedFormsValidator.validateGenericRequiredField(this.values.tenant);

        this.tenantValidationMessage = validation.errors.first('field');
        this.formErrors.push(validation.errorCount);
    }


    @action validateForm() {
        this.formErrors = [];
        this.validateUserName();
        this.validatePassword();
        ConfigurationsStore.isMultitenancyMode && this.validateTenant();

        if (this.formErrors.filter((valid) => valid > 0).length > 0) {
            return false;
        }

        return true;
    }

    @action validateTenantForm() {
        this.formErrors = [];
        this.validateTenant();
        if (this.formErrors.filter((valid) => valid > 0).length > 0) {
            return false;
        }

        return true;
    }

    @computed get selectedAuthProviderId() {
        const id = parseInt(this.values.providerId);

        if (isNaN(id)) {

            return this.DEFAULT_AUTH_PROVIDER_ID;
        }

        return id;
    }

    @action validateTwoFactorLoginToken() {
        const validation = CommonValidator.validateGenericRequiredFieldWithConcreteName('Two-Factor Token', this.values.authenticationCode);
        this.twoFactorErrorMessage = validation.errors.first('Two-Factor Token');
        this.formErrors.push(validation.errorCount);
    }

    @action validateTwoFactorLoginForm() {
        this.formErrors = [];
        this.validateTwoFactorLoginToken();
        if (this.formErrors.filter((valid) => valid > 0).length > 0) {
            return false;
        }
        return true;
    }

    @action validateRecoveryCode() {
        const validation = CommonValidator.validateGenericRequiredFieldWithConcreteName('Recovery Code', this.values.recoveryCode);
        this.recoveryCodeErrorMessage = validation.errors.first('Recovery Code');
        this.formErrors.push(validation.errorCount);
    }

    @action validateRecoveryCodeLoginForm() {
        this.formErrors = [];
        this.validateRecoveryCode();
        if (this.formErrors.filter((valid) => valid > 0).length > 0) {
            return false;
        }
        return true;
    }

}

export default new AuthStore();